<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body no-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <ul class="nav nav-pills" role="tablist">
      <li [class.active]="activeTab === 0"><a (click)="onTabChange(0)" style="cursor: pointer;">Form Entry</a></li>
      <li [class.active]="activeTab === 1"><a (click)="onTabChange(1)" style="cursor: pointer;">Form View</a></li>
    </ul>

    <div class="tab-content" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <!-- Form Entry tab (migrated from Form-scheduleDEntry.html) -->
      @if (activeTab === 0) {
<div class="form-horizontal tab-content-padding">
        <div class="row">
          @if (scheduleDFormEntry?.section1?.singlerows?.length) {
<table class="table table-bordered form-inline">
            <tbody>
              <tr class="text-right">
                @for (row of scheduleDFormEntry.section1.singlerows; track $index) {
<td [ngClass]="{'color-red': row < 0 }">
                  <span style="font-weight:bold; font-size:18px"><strong>{{ row | numberWithCommas }}</strong></span>
                </td>
}
              </tr>
            </tbody>
          </table>
}

          <div class="col-md-12">
            <h4 style="font-weight: bold;">Part I: {{ scheduleDFormEntry?.section1?.part1Title }}</h4>
          </div>

          <table class="table table-bordered form-inline custom-table">
            <thead>
              <tr>
                @for (header of scheduleDLine1Headers; track $index) {
<th>{{ header.name }}</th>
}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1<i class="fa fa-plus-circle color-green fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" (click)="sectionAdd(1)" title="Add Details"></i></td>
                <td style="border-bottom-width: 0px;" colspan="11">Add Gain or (Loss) Details</td>
              </tr>

              @for (row of formData_1.addrows; track $index; let i = $index) {
<tr class="text-center">
                <td style="border-right-width: 0px">
                  <i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" (click)="sectionRemove(1, i)" title="Remove Details"></i>
                </td>
                <td colspan="11" style="padding: 0px; border: 0px">
                  <table width="100%" class="table table-bordered form-inline table-no-border table-no-bottom-margin">
                    <tbody>
                      <tr>
                        <td style="width: 180px">
                          <input class="form-control" type="text" style="width: 162px !important"
                                 [ngModel]="formData_1.addrows[i][0]?.Attribute_Value" (ngModelChange)="formData_1.addrows[i][0].Attribute_Value = $event; errorChange(1, i, 0)">
                          @if (formData_1_errorMessages.addrows[i]?.[0]?.column_error) {
<span class="form-error-container">{{ formData_1_errorMessages.addrows[i][0].column_error }}</span>
}
                        </td>
                        <td style="width: 213px">
                          <input class="form-control" type="date" [ngModel]="formData_1.addrows[i][1]?.Attribute_Value" (ngModelChange)="formData_1.addrows[i][1].Attribute_Value = $event; errorChange(1, i, 1)">
                          @if (formData_1_errorMessages.addrows[i]?.[1]?.column_error) {
<span class="form-error-container">{{ formData_1_errorMessages.addrows[i][1].column_error }}</span>
}
                        </td>
                        <td style="width: 177px">
                          <input class="form-control" type="date" [ngModel]="formData_1.addrows[i][2]?.Attribute_Value" (ngModelChange)="formData_1.addrows[i][2].Attribute_Value = $event; errorChange(1, i, 2)">
                          @if (formData_1_errorMessages.addrows[i]?.[2]?.column_error) {
<span class="form-error-container">{{ formData_1_errorMessages.addrows[i][2].column_error }}</span>
}
                        </td>
                        <td style="width: 136px">
                          <input class="form-control input-sm numText" style="text-align: right; width:115px" type="text"
                                 [ngModel]="formData_1.addrows[i][3]?.Attribute_Value" (ngModelChange)="formData_1.addrows[i][3].Attribute_Value = $event; errorChange(1, i, 3)"
                                 (blur)="setGainLoss(1, false, i)">
                          @if (formData_1_errorMessages.addrows[i]?.[3]?.column_error) {
<span class="form-error-container">{{ formData_1_errorMessages.addrows[i][3].column_error }}</span>
}
                        </td>
                        <td style="width: 148px">
                          <input class="form-control input-sm numText" style="text-align: right; width:120px" type="text"
                                 [ngModel]="formData_1.addrows[i][4]?.Attribute_Value" (ngModelChange)="formData_1.addrows[i][4].Attribute_Value = $event; errorChange(1, i, 4)"
                                 (blur)="setGainLoss(1, false, i)">
                          @if (formData_1_errorMessages.addrows[i]?.[4]?.column_error) {
<span class="form-error-container">{{ formData_1_errorMessages.addrows[i][4].column_error }}</span>
}
                        </td>
                        <td style="width:140px">
                          <label><input type="radio" [name]="'a1_transactionType_1_' + i" value="Perm" [ngModel]="formData_1.addrows[i][5]?.Attribute_Value" (ngModelChange)="formData_1.addrows[i][5].Attribute_Value = $event; errorChange(1, i, 5)"/>Perm</label>
                          <label><input type="radio" [name]="'a1_transactionType_1_' + i" value="Temp" [ngModel]="formData_1.addrows[i][5]?.Attribute_Value" (ngModelChange)="formData_1.addrows[i][5].Attribute_Value = $event; errorChange(1, i, 5)"/>Temp</label>
                          @if (formData_1_errorMessages.addrows[i]?.[5]?.column_error) {
<span class="form-error-container">{{ formData_1_errorMessages.addrows[i][5].column_error }}</span>
}
                        </td>
                        <td style="width:145px"><input type="checkbox" [ngModel]="formData_1.addrows[i][6]?.Attribute_Value === 'Y'" (ngModelChange)="formData_1.addrows[i][6].Attribute_Value = $event ? 'Y' : 'N'; errorChange(1, i, 6)"></td>
                        <td style="width:139px"><input type="checkbox" [ngModel]="formData_1.addrows[i][7]?.Attribute_Value === 'Y'" (ngModelChange)="formData_1.addrows[i][7].Attribute_Value = $event ? 'Y' : 'N'; errorChange(1, i, 7)"></td>
                        <td style="width: 108px"><input type="checkbox" [ngModel]="formData_1.addrows[i][8]?.Attribute_Value === 'Y'" (ngModelChange)="formData_1.addrows[i][8].Attribute_Value = $event ? 'Y' : 'N'; errorChange(1, i, 8)"></td>
                        <td style="width: 155px"><input type="checkbox" [ngModel]="formData_1.addrows[i][9]?.Attribute_Value === 'Y'" (ngModelChange)="formData_1.addrows[i][9].Attribute_Value = $event ? 'Y' : 'N'; errorChange(1, i, 9)"></td>
                        <td align="right" style="width: 110px" [ngClass]="{'color-red': formData_1.addrows[i][10]?.Attribute_Value < 0 }">
                          <p>{{ formData_1.addrows[i][10]?.Attribute_Value | numberWithCommas }}</p>
                          @if (formData_1_errorMessages.addrows[i]?.[10]?.column_error) {
<span class="form-error-container">{{ formData_1_errorMessages.addrows[i][10].column_error }}</span>
}
                        </td>
                      </tr>
                      <tr>
                        <td style="border-bottom-width: 0px; text-align: left !important"><h4 style="font-weight: bold;">{{ scheduleDLine1HeaderComment?.name }}:</h4></td>
                        <td colspan="10" style="width: 180px; border-bottom-width: 0px">
                          <textarea style="width: 100%" class="form-control input-sm" placeholder="<--- Enter Comments here --->"
                                    [ngModel]="formData_1.addrows[i][11]?.Attribute_Value" (ngModelChange)="formData_1.addrows[i][11].Attribute_Value = $event; errorChange(1, i, 11)"></textarea>
                          @if (formData_1_errorMessages.addrows[i]?.[11]?.column_error) {
<span class="form-error-container">{{ formData_1_errorMessages.addrows[i][11].column_error }}</span>
}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
}

              @for (t of scheduleDLine1Records; track $index; let i = $index) {
<tr>
                <td style="border-right-width: 0px">
                  <i class="fa fa-pencil bluepencil pull-left" style="cursor: pointer; margin-top: 4px;" title="Edit Details" (click)="editExistingRecord(1, i, t.rowDimensions?.object_id)"></i>
                  <i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" title="Remove Details" (click)="removeExistingRecord(1, i, t.rowDimensions?.object_id)"></i>
                </td>
                <td colspan="11" style="padding: 0px; border: 0px">
                  <table width="100%" class="table table-bordered form-inline table-no-border table-no-bottom-margin">
                    <tbody>
                      <tr>
                        <td style="width: 180px">
                          @if (displayViewValue_1[i]) {
<div>{{ t.dataCellList?.[1]?.value }}</div>
}
                          @if (displayEditValue_1[i]) {
<div>
                            <input class="form-control" style="width: 162px !important" type="text" [ngModel]="t.dataCellList?.[1]?.value" (ngModelChange)="t.dataCellList[1].value = $event; propChange(1, 0, i)">
                            @if (t.dataCellList?.[1]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[1].error_message }}</span>
}
                          </div>
}
                        </td>
                        <td style="width: 213px">
                          @if (displayViewValue_1[i]) {
<div>{{ t.dataCellList?.[2]?.value | date:'MM/dd/yyyy' }}</div>
}
                          @if (displayEditValue_1[i]) {
<div>
                            <input type="date" [ngModel]="t.dataCellList?.[2]?.value" (ngModelChange)="t.dataCellList[2].value = $event; propChange(1, 1, i)">
                            @if (t.dataCellList?.[2]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[2].error_message }}</span>
}
                          </div>
}
                        </td>
                        <td style="width: 177px">
                          @if (displayViewValue_1[i]) {
<div>{{ t.dataCellList?.[3]?.value | date:'MM/dd/yyyy' }}</div>
}
                          @if (displayEditValue_1[i]) {
<div>
                            <input type="date" [ngModel]="t.dataCellList?.[3]?.value" (ngModelChange)="t.dataCellList[3].value = $event; propChange(1, 2, i)">
                            @if (t.dataCellList?.[3]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[3].error_message }}</span>
}
                          </div>
}
                        </td>
                        <td style="width: 136px" align="right">
                          @if (displayViewValue_1[i]) {
<div><span [ngClass]="{'color-red': t.dataCellList?.[4]?.value < 0 }">{{ t.dataCellList?.[4]?.value | numberWithCommas }}</span></div>
}
                          @if (displayEditValue_1[i]) {
<div>
                            <input class="form-control input-sm numText" style="text-align: right; width:115px" type="text" [ngModel]="t.dataCellList?.[4]?.value" (ngModelChange)="t.dataCellList[4].value = $event; propChange(1, 3, i)" (blur)="setGainLoss(1, true, i)">
                            @if (t.dataCellList?.[4]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[4].error_message }}</span>
}
                          </div>
}
                        </td>
                        <td style="width: 148px" align="right">
                          @if (displayViewValue_1[i]) {
<div><span [ngClass]="{'color-red': t.dataCellList?.[5]?.value < 0 }">{{ t.dataCellList?.[5]?.value | numberWithCommas }}</span></div>
}
                          @if (displayEditValue_1[i]) {
<div>
                            <input class="form-control input-sm numText" style="text-align: right; width:120px" type="text" [ngModel]="t.dataCellList?.[5]?.value" (ngModelChange)="t.dataCellList[5].value = $event; propChange(1, 4, i)" (blur)="setGainLoss(1, true, i)">
                            @if (t.dataCellList?.[5]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[5].error_message }}</span>
}
                          </div>
}
                        </td>
                        <td style="width: 140px">
                          @if (displayViewValue_1[i]) {
<div>{{ t.dataCellList?.[6]?.value }}</div>
}
                          @if (displayEditValue_1[i]) {
<div>
                            <label><input type="radio" [name]="'e1_transactionType_' + i" value="Perm" [ngModel]="t.dataCellList?.[6]?.value" (ngModelChange)="t.dataCellList[6].value = $event; propChange(1, 5, i)"/>Perm</label>
                            <label><input type="radio" [name]="'e1_transactionType_' + i" value="Temp" [ngModel]="t.dataCellList?.[6]?.value" (ngModelChange)="t.dataCellList[6].value = $event; propChange(1, 5, i)"/>Temp</label>
                            @if (t.dataCellList?.[6]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[6].error_message }}</span>
}
                          </div>
}
                        </td>
                        <td style="width: 145px">@if (displayViewValue_1[i]) {
<div>{{ t.dataCellList?.[7]?.value }}</div>
}@if (displayEditValue_1[i]) {
<div><input type="checkbox" [ngModel]="t.dataCellList?.[7]?.value === 'Y'" (ngModelChange)="t.dataCellList[7].value = $event ? 'Y' : 'N'; propChange(1, 6, i)"></div>
}</td>
                        <td style="width: 139px">@if (displayViewValue_1[i]) {
<div>{{ t.dataCellList?.[8]?.value }}</div>
}@if (displayEditValue_1[i]) {
<div><input type="checkbox" [ngModel]="t.dataCellList?.[8]?.value === 'Y'" (ngModelChange)="t.dataCellList[8].value = $event ? 'Y' : 'N'; propChange(1, 7, i)"></div>
}</td>
                        <td style="width: 108px">@if (displayViewValue_1[i]) {
<div>{{ t.dataCellList?.[9]?.value }}</div>
}@if (displayEditValue_1[i]) {
<div><input type="checkbox" [ngModel]="t.dataCellList?.[9]?.value === 'Y'" (ngModelChange)="t.dataCellList[9].value = $event ? 'Y' : 'N'; propChange(1, 8, i)"></div>
}</td>
                        <td style="width: 155px">@if (displayViewValue_1[i]) {
<div>{{ t.dataCellList?.[10]?.value }}</div>
}@if (displayEditValue_1[i]) {
<div><input type="checkbox" [ngModel]="t.dataCellList?.[10]?.value === 'Y'" (ngModelChange)="t.dataCellList[10].value = $event ? 'Y' : 'N'; propChange(1, 9, i)"></div>
}</td>
                        <td style="width: 110px" align="right" [ngClass]="{'color-red': t.dataCellList?.[11]?.value < 0 }"><p>{{ t.dataCellList?.[11]?.value | numberWithCommas }}</p></td>
                      </tr>
                      @if (displayViewValueComment_1[i] && t.dataCellList?.[12]?.value != null) {
<tr>
                        <td style="border-bottom-width: 0px"><h4 style="font-weight: bold;">{{ scheduleDLine1HeaderComment?.name }}:</h4></td>
                        <td colspan="10">@if (displayViewValue_1[i]) {
<div>{{ t.dataCellList?.[12]?.value }}</div>
}</td>
                      </tr>
}
                      @if (displayEditValueComment_1[i]) {
<tr>
                        <td style="border-bottom-width: 0px"><h4 style="font-weight: bold;">{{ scheduleDLine1HeaderComment?.name }}:</h4></td>
                        <td colspan="10">
                          <textarea style="width: 100%" class="form-control input-sm" placeholder="<--- Enter Comments here --->" [ngModel]="t.dataCellList?.[12]?.value" (ngModelChange)="t.dataCellList[12].value = $event; propChange(1, 11, i)"></textarea>
                          @if (t.dataCellList?.[12]?.error_message) {
<span class="form-error-container">{{ t.dataCellList[12].error_message }}</span>
}
                        </td>
                      </tr>
}
                    </tbody>
                  </table>
                </td>
              </tr>
}

              <tr>
                <td style="width: 58px">4</td>
                <td colspan="10">Unused capital loss carryover (attach computation)</td>
                <td style="width: 110px" align="right">
                  @if (displayLine4Edit) {
<div><input class="form-control input-sm numText" style="text-align: right; width:100px" type="text"
                         [ngModel]="unUsedCapLossCarryOver" (ngModelChange)="unUsedCapLossCarryOver = $event; line4Change()"
                         (blur)="adjustGainLoss()"></div>
}
                </td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-md-12"><h4 style="font-weight: bold;">Part II: {{ scheduleDFormEntry?.section2?.part2Title }}</h4></div>
            <table class="table table-bordered form-inline custom-table">
              <thead><tr>@for (header of scheduleDLine6Headers; track $index) {
<th>{{ header.name }}</th>
}</tr></thead>
              <tbody>
                <tr>
                  <td>6<i class="fa fa-plus-circle color-green fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" (click)="sectionAdd(6)" title="Add Details"></i></td>
                  <td style="border-bottom-width: 0px;" colspan="11">Add Gain or (Loss) Details</td>
                </tr>
                @for (row of formData_6.addrows; track $index; let i = $index) {
<tr class="text-center">
                  <td style="border-right-width: 0px"><i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" (click)="sectionRemove(6, i)" title="Remove Details"></i></td>
                  <td colspan="11" style="padding: 0px; border: 0px">
                    <table width="100%" class="table table-bordered form-inline table-no-border table-no-bottom-margin">
                      <tbody>
                        <tr>
                          <td style="width: 180px"><input class="form-control" type="text" style="width: 162px !important" [ngModel]="formData_6.addrows[i][0]?.Attribute_Value" (ngModelChange)="formData_6.addrows[i][0].Attribute_Value = $event; errorChange(6, i, 0)"></td>
                          <td style="width: 213px"><input class="form-control" type="date" [ngModel]="formData_6.addrows[i][1]?.Attribute_Value" (ngModelChange)="formData_6.addrows[i][1].Attribute_Value = $event; errorChange(6, i, 1)"></td>
                          <td style="width: 177px"><input class="form-control" type="date" [ngModel]="formData_6.addrows[i][2]?.Attribute_Value" (ngModelChange)="formData_6.addrows[i][2].Attribute_Value = $event; errorChange(6, i, 2)"></td>
                          <td style="width: 136px"><input class="form-control input-sm numText" style="text-align: right; width:115px" type="text" [ngModel]="formData_6.addrows[i][3]?.Attribute_Value" (ngModelChange)="formData_6.addrows[i][3].Attribute_Value = $event; errorChange(6, i, 3)" (blur)="setGainLoss(6, false, i)"></td>
                          <td style="width: 148px"><input class="form-control input-sm numText" style="text-align: right; width:120px" type="text" [ngModel]="formData_6.addrows[i][4]?.Attribute_Value" (ngModelChange)="formData_6.addrows[i][4].Attribute_Value = $event; errorChange(6, i, 4)" (blur)="setGainLoss(6, false, i)"></td>
                          <td style="width: 140px"><label><input type="radio" [name]="'a6_transactionType_' + i" value="Perm" [ngModel]="formData_6.addrows[i][5]?.Attribute_Value" (ngModelChange)="formData_6.addrows[i][5].Attribute_Value = $event; errorChange(6, i, 5)"/>Perm</label><label><input type="radio" [name]="'a6_transactionType_' + i" value="Temp" [ngModel]="formData_6.addrows[i][5]?.Attribute_Value" (ngModelChange)="formData_6.addrows[i][5].Attribute_Value = $event; errorChange(6, i, 5)"/>Temp</label></td>
                          <td style="width: 145px"><input type="checkbox" [ngModel]="formData_6.addrows[i][6]?.Attribute_Value === 'Y'" (ngModelChange)="formData_6.addrows[i][6].Attribute_Value = $event ? 'Y' : 'N'; errorChange(6, i, 6)"></td>
                          <td style="width: 139px"><input type="checkbox" [ngModel]="formData_6.addrows[i][7]?.Attribute_Value === 'Y'" (ngModelChange)="formData_6.addrows[i][7].Attribute_Value = $event ? 'Y' : 'N'; errorChange(6, i, 7)"></td>
                          <td style="width: 108px"><input type="checkbox" [ngModel]="formData_6.addrows[i][8]?.Attribute_Value === 'Y'" (ngModelChange)="formData_6.addrows[i][8].Attribute_Value = $event ? 'Y' : 'N'; errorChange(6, i, 8)"></td>
                          <td style="width: 155px"><input type="checkbox" [ngModel]="formData_6.addrows[i][9]?.Attribute_Value === 'Y'" (ngModelChange)="formData_6.addrows[i][9].Attribute_Value = $event ? 'Y' : 'N'; errorChange(6, i, 9)"></td>
                          <td align="right" style="width: 110px" [ngClass]="{'color-red': formData_6.addrows[i][10]?.Attribute_Value < 0 }"><p>{{ formData_6.addrows[i][10]?.Attribute_Value | numberWithCommas }}</p></td>
                        </tr>
                        <tr>
                          <td style="border-bottom-width: 0px; text-align: left !important"><h4 style="font-weight: bold;">{{ scheduleDLine6HeaderComment?.name }}:</h4></td>
                          <td colspan="10"><textarea style="width: 100%" class="form-control input-sm" placeholder="<--- Enter Comments here --->" [ngModel]="formData_6.addrows[i][11]?.Attribute_Value" (ngModelChange)="formData_6.addrows[i][11].Attribute_Value = $event; errorChange(6, i, 11)"></textarea></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
}

                @for (t of scheduleDLine6Records; track $index; let i = $index) {
<tr>
                  <td style="border-right-width: 0px">
                    <i class="fa fa-pencil bluepencil pull-left" style="cursor: pointer; margin-top: 4px;" (click)="editExistingRecord(6, i, t.rowDimensions?.object_id)" title="Edit Details"></i>
                    <i class="fa fa-minus-circle color-red fa-lg pull-right" style="cursor: pointer; margin-top: 4px;" (click)="removeExistingRecord(6, i, t.rowDimensions?.object_id)" title="Remove Details"></i>
                  </td>
                  <td colspan="11" style="padding: 0px; border: 0px">
                    <table width="100%" class="table table-bordered form-inline table-no-border table-no-bottom-margin">
                      <tbody>
                        <tr>
                          <td style="width: 180px">@if (displayViewValue_6[i]) {
<div>{{ t.dataCellList?.[1]?.value }}</div>
}@if (displayEditValue_6[i]) {
<div><input class="form-control" style="width: 162px !important" type="text" [ngModel]="t.dataCellList?.[1]?.value" (ngModelChange)="t.dataCellList[1].value = $event; propChange(6, 0, i)"></div>
}</td>
                          <td style="width: 213px">@if (displayViewValue_6[i]) {
<div>{{ t.dataCellList?.[2]?.value | date:'MM/dd/yyyy' }}</div>
}@if (displayEditValue_6[i]) {
<div><input type="date" [ngModel]="t.dataCellList?.[2]?.value" (ngModelChange)="t.dataCellList[2].value = $event; propChange(6, 1, i)"></div>
}</td>
                          <td style="width: 177px">@if (displayViewValue_6[i]) {
<div>{{ t.dataCellList?.[3]?.value | date:'MM/dd/yyyy' }}</div>
}@if (displayEditValue_6[i]) {
<div><input type="date" [ngModel]="t.dataCellList?.[3]?.value" (ngModelChange)="t.dataCellList[3].value = $event; propChange(6, 2, i)"></div>
}</td>
                          <td style="width: 136px" align="right">@if (displayViewValue_6[i]) {
<div><span [ngClass]="{'color-red': t.dataCellList?.[4]?.value < 0 }">{{ t.dataCellList?.[4]?.value | numberWithCommas }}</span></div>
}@if (displayEditValue_6[i]) {
<div><input class="form-control input-sm numText" style="text-align: right; width:115px" type="text" [ngModel]="t.dataCellList?.[4]?.value" (ngModelChange)="t.dataCellList[4].value = $event; propChange(6, 3, i)" (blur)="setGainLoss(6, true, i)"></div>
}</td>
                          <td style="width: 148px" align="right">@if (displayViewValue_6[i]) {
<div><span [ngClass]="{'color-red': t.dataCellList?.[5]?.value < 0 }">{{ t.dataCellList?.[5]?.value | numberWithCommas }}</span></div>
}@if (displayEditValue_6[i]) {
<div><input class="form-control input-sm numText" style="text-align: right; width:120px" type="text" [ngModel]="t.dataCellList?.[5]?.value" (ngModelChange)="t.dataCellList[5].value = $event; propChange(6, 4, i)" (blur)="setGainLoss(6, true, i)"></div>
}</td>
                          <td style="width: 140px">@if (displayViewValue_6[i]) {
<div>{{ t.dataCellList?.[6]?.value }}</div>
}@if (displayEditValue_6[i]) {
<div><label><input type="radio" [name]="'e6_transactionType_' + i" value="Perm" [ngModel]="t.dataCellList?.[6]?.value" (ngModelChange)="t.dataCellList[6].value = $event; propChange(6, 5, i)"/>Perm</label><label><input type="radio" [name]="'e6_transactionType_' + i" value="Temp" [ngModel]="t.dataCellList?.[6]?.value" (ngModelChange)="t.dataCellList[6].value = $event; propChange(6, 5, i)"/>Temp</label></div>
}</td>
                          <td style="width: 145px">@if (displayViewValue_6[i]) {
<div>{{ t.dataCellList?.[7]?.value }}</div>
}@if (displayEditValue_6[i]) {
<div><input type="checkbox" [ngModel]="t.dataCellList?.[7]?.value === 'Y'" (ngModelChange)="t.dataCellList[7].value = $event ? 'Y' : 'N'; propChange(6, 6, i)"></div>
}</td>
                          <td style="width: 139px">@if (displayViewValue_6[i]) {
<div>{{ t.dataCellList?.[8]?.value }}</div>
}@if (displayEditValue_6[i]) {
<div><input type="checkbox" [ngModel]="t.dataCellList?.[8]?.value === 'Y'" (ngModelChange)="t.dataCellList[8].value = $event ? 'Y' : 'N'; propChange(6, 7, i)"></div>
}</td>
                          <td style="width: 108px">@if (displayViewValue_6[i]) {
<div>{{ t.dataCellList?.[9]?.value }}</div>
}@if (displayEditValue_6[i]) {
<div><input type="checkbox" [ngModel]="t.dataCellList?.[9]?.value === 'Y'" (ngModelChange)="t.dataCellList[9].value = $event ? 'Y' : 'N'; propChange(6, 8, i)"></div>
}</td>
                          <td style="width: 155px">@if (displayViewValue_6[i]) {
<div>{{ t.dataCellList?.[10]?.value }}</div>
}@if (displayEditValue_6[i]) {
<div><input type="checkbox" [ngModel]="t.dataCellList?.[10]?.value === 'Y'" (ngModelChange)="t.dataCellList[10].value = $event ? 'Y' : 'N'; propChange(6, 9, i)"></div>
}</td>
                          <td style="width: 110px" align="right" [ngClass]="{'color-red': t.dataCellList?.[11]?.value < 0 }"><p>{{ t.dataCellList?.[11]?.value | numberWithCommas }}</p></td>
                        </tr>
                        @if (displayEditValueComment_6[i]) {
<tr><td style="border-bottom-width: 0px"><h4 style="font-weight: bold;">{{ scheduleDLine6HeaderComment?.name }}:</h4></td><td colspan="10"><textarea style="width: 100%" class="form-control input-sm" placeholder="<--- Enter Comments here --->" [ngModel]="t.dataCellList?.[12]?.value" (ngModelChange)="t.dataCellList[12].value = $event; propChange(6, 11, i)"></textarea></td></tr>
}
                      </tbody>
                    </table>
                  </td>
                </tr>
}

                <tr class="text-right">
                  <td><span style="font-weight:bold; font-size:18px"><strong>Total Schd D Gain or (Loss)</strong></span></td>
                  <td align="right" [ngClass]="{'color-red': schdDSum < 0 }"><span style="font-weight:bold; font-size:18px"><strong>{{ schdDSum | numberWithCommas }}</strong></span></td>
                </tr>
                <tr class="text-right">
                  <td><span style="font-weight:bold; font-size:18px">Unallocated Amount</span></td>
                  <td align="right" [ngClass]="{'color-red': unallocatedAmount < 0 }"><span style="font-weight:bold; font-size:18px"><strong>{{ unallocatedAmount | numberWithCommas }}</strong></span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
}

      <!-- Form View tab (migrated from Form-scheduleDView.html) -->
      @if (activeTab === 1) {
<div class="form-horizontal tab-content-padding">
        <div class="row">
          <div class="col-md-12 font-weight-bold">
            <h4 style="font-weight: bold;">Part I: {{ scheduleDFormView?.section1?.part1Title }}</h4>
          </div>
          <table class="table table-bordered form-inline custom-table">
            <thead><tr>@for (header of scheduleDFormView?.section1?.tableHeaders; track $index) {
<th>{{ header }}</th>
}</tr></thead>
            <tbody>
              @for (row of scheduleDFormView?.section1?.rows; track $index) {
<tr>
                <td>{{ row.num }}</td>
                <td>{{ row.description }}</td>
                <td>@if (row.proceeds?.show) {
<input class="form-control" type="text">
}</td>
                <td>@if (row.cost?.show) {
<input class="form-control" type="text">
}</td>
                <td>@if (row.adjustment?.show) {
<input class="form-control" type="text">
}</td>
                <td>@if (row.gain?.show) {
<input class="form-control" type="text">
}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-md-12 font-weight-bold">
            <h4 style="font-weight: bold;">Part II: {{ scheduleDFormView?.section2?.part1Title }}</h4>
          </div>
          <table class="table table-bordered form-inline custom-table">
            <thead><tr>@for (header of scheduleDFormView?.section1?.tableHeaders; track $index) {
<th>{{ header }}</th>
}</tr></thead>
            <tbody>
              @for (row of scheduleDFormView?.section2?.rows; track $index) {
<tr>
                <td>{{ row.num }}</td>
                <td>{{ row.description }}</td>
                <td>@if (row.proceeds?.show) {
<input class="form-control" type="text">
}</td>
                <td>@if (row.cost?.show) {
<input class="form-control" type="text">
}</td>
                <td>@if (row.adjustment?.show) {
<input class="form-control" type="text">
}</td>
                <td>@if (row.gain?.show) {
<input class="form-control" type="text">
}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-md-12 font-weight-bold">
            <h4 style="font-weight: bold;">Part III: {{ scheduleDFormView?.section3?.part3Title }}</h4>
          </div>
          <table class="table table-bordered form-inline custom-table">
            <thead><tr>@for (header of scheduleDFormView?.section1?.tableHeaders; track $index) {
<th>{{ header }}</th>
}</tr></thead>
            <tbody>
              @for (row of scheduleDFormView?.section3?.rows; track $index) {
<tr>
                <td>{{ row.num }}</td>
                <td>{{ row.description }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td>@if (row.gain?.show) {
<input class="form-control" type="text">
}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
}
    </div>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="crudLoading" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save and Proceed
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
